import { render } from "./Recommend.vue?vue&type=template&id=aa30ff3c&scoped=true"
const script = {}

import "./Recommend.vue?vue&type=style&index=0&id=aa30ff3c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa30ff3c"]])

export default __exports__